(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nine-home-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const respectMotion = () => {
    if (reduceMotion.matches) document.querySelectorAll('.nine-home-campaign video').forEach(video => { video.autoplay = false; video.pause(); });
  };
  respectMotion();
  reduceMotion.addEventListener('change', respectMotion);
  document.addEventListener('shopify:section:load', respectMotion);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nine-journey"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nine-journey')) {
  customElements.define('nine-journey', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-journey-category]')];
      this.buttons = [...this.querySelectorAll('[data-journey-filter]')];
      this.querySelector('.nine-journey__filters').hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => this.filter(button.dataset.journeyFilter)));
      this.addEventListener('shopify:block:select', () => this.filter('all'));
    }
    filter(category) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.journeyFilter === category)));
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = category !== 'all' && card.dataset.journeyCategory !== category;
        if (!card.hidden) count += 1;
      });
      this.querySelector('[data-journey-count]').textContent = count;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
